/* Euro Premium Parts - optional VIN (first 11 characters): recognizes the customer's car (free NHTSA vPIC decoder),
   fills the "Select my car" menus, and pre-fills the VIN field on product pages. */
(function () {
  if (window.ErpVin) return;
  var KEY = 'erpVehicle';
  var LEN = 11; // only the first 11 characters are collected (maker, model, year, plant): never the serial number
  var VIN_RE = /^[A-HJ-NPR-Z0-9]{11}$/;
  var ALIAS = { gti: 'golf', golfr: 'golf', golfgti: 'golf', cc: 'passat' };

  function norm(s) {
    return (s || '').toString().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]/g, '');
  }
  function cleanVin(v) { return (v || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, LEN); }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function titleCase(s) {
    return (s || '').toLowerCase().replace(/(^|[\s-])([a-z])/g, function (m, p, c) { return p + c.toUpperCase(); });
  }

  var cache = {};
  function decode(vin) {
    if (cache[vin]) return cache[vin];
    cache[vin] = fetch('https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValues/' + vin + '?format=json')
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
      .then(function (j) {
        var x = (j && j.Results && j.Results[0]) || {};
        var car = { vin: vin, make: x.Make || '', model: x.Model || '', series: x.Series || '', year: parseInt(x.ModelYear, 10) || null, plant: x.PlantCountry || '' };
        if (!car.make) throw new Error('unknown');
        var make = car.make.toUpperCase() === 'BMW' ? 'BMW' : titleCase(car.make);
        car.label = [car.year, make, car.model].filter(Boolean).join(' ');
        return car;
      });
    cache[vin].catch(function () { delete cache[vin]; });
    return cache[vin];
  }

  /* ---------- "Select my car" menus ---------- */
  function options(nav, level, parent) {
    var sel = nav.querySelector('custom-select[data-level="' + level + '"]');
    if (!sel) return { sel: null, list: [] };
    var list = Array.prototype.slice.call(sel.querySelectorAll('.custom-select__option')).filter(function (o) {
      return o.dataset.value && (level === 1 || o.dataset.parentHandle === parent);
    });
    return { sel: sel, list: list };
  }
  function label(o) { return (o.textContent || '').replace(/\s+/g, ' ').trim(); }

  function pickMake(list, car) {
    var m = norm(car.make);
    return list.filter(function (o) { return norm(label(o)) === m; })[0] || null;
  }
  function pickModel(list, car) {
    var cands = [norm(car.series), norm(car.model)];
    var mm = /^m(\d)/i.exec(car.model || '');
    if (mm) cands.push(mm[1] + 'series');
    cands = cands.filter(Boolean).map(function (c) { return ALIAS[c] || c; });
    var best = null, bestScore = 0;
    list.forEach(function (o) {
      label(o).split('/').map(norm).forEach(function (alt) {
        if (!alt) return;
        cands.forEach(function (c) {
          var s = c === alt ? 3 : (alt.length >= 2 && c.indexOf(alt) === 0) ? 2 : (alt.length >= 3 && c.indexOf(alt) > -1) ? 1 : 0;
          if (s > bestScore) { bestScore = s; best = o; }
        });
      });
    });
    return best;
  }
  function pickGeneration(list, car) {
    if (!car.year) return null;
    // US-built Passat (2012+) is the North American NMS platform, not the European B7/B8: let the customer choose.
    if (norm(car.model).indexOf('passat') === 0 && /UNITED STATES/i.test(car.plant)) return null;
    var hits = list.filter(function (o) {
      var r = /(\d{4})\s*-\s*(\d{4})/.exec(label(o));
      return r && car.year >= +r[1] && car.year <= +r[2];
    });
    if (hits.length > 1 && car.model) {
      var m = norm(car.model);
      var named = hits.filter(function (o) { return norm(label(o)).indexOf(m) > -1; });
      if (named.length === 1) return named[0];
    }
    return hits.length === 1 ? hits[0] : null;
  }
  function choose(sel, opt) {
    if (sel && opt && typeof sel.selectOption === 'function') sel.selectOption(opt);
  }

  // Puts the three menus back to "Make / Model / Year" so a previous car never stays selected.
  function resetNav(nav) {
    var QN = customElements.get('quick-nav');
    [1, 2, 3].forEach(function (l) {
      var s = nav.querySelector('custom-select[data-level="' + l + '"]');
      if (!s) return;
      if (QN && QN.resetSelect) QN.resetSelect(s, l > 1);
      var d = s.querySelector('.quick-nav__default-option') || s.querySelector('.custom-select__option');
      if (d) { s.selectedOption = d; d.setAttribute('aria-selected', 'true'); }
    });
    if (typeof nav.updateSubmitButton === 'function') nav.updateSubmitButton('');
    if (typeof nav.unparseCollectionInfo === 'function') nav.unparseCollectionInfo();
  }

  function fillNav(nav, car, status) {
    resetNav(nav);
    var lv1 = options(nav, 1);
    var make = pickMake(lv1.list, car);
    if (!make) {
      status('ok', 'Recognized: <strong>' + car.label + '</strong>.');
      return;
    }
    choose(lv1.sel, make);
    var lv2 = options(nav, 2, make.dataset.value);
    var model = pickModel(lv2.list, car);
    if (!model) {
      status('ok', 'Recognized: <strong>' + car.label + '</strong>. Pick your model below.');
      return;
    }
    choose(lv2.sel, model);
    var lv3 = options(nav, 3, model.dataset.value);
    var gen = pickGeneration(lv3.list, car);
    if (gen) {
      choose(lv3.sel, gen);
      status('ok', 'Recognized: <strong>' + car.label + '</strong> &middot; ' + label(gen) + '. Your parts are one click away.');
    } else if (lv3.list.length) {
      status('ok', 'Recognized: <strong>' + car.label + '</strong>. Pick your generation below.');
    } else {
      status('ok', 'Recognized: <strong>' + car.label + '</strong>. Your parts are one click away.');
    }
  }

  /* ---------- shared input behaviour ---------- */
  function bind(input, statusEl, onCar) {
    function status(kind, html) {
      if (!statusEl) return;
      statusEl.hidden = !html;
      statusEl.className = 'erp-vin__status' + (kind ? ' is-' + kind : '');
      statusEl.innerHTML = html || '';
    }
    var last = '';
    function run() {
      var vin = cleanVin(input.value);
      if (vin === last) return;
      last = vin;
      if (!vin) { try { localStorage.removeItem(KEY); } catch (e) {} status('', ''); return; }
      if (vin.length < LEN) { status('', ''); return; }
      if (!VIN_RE.test(vin)) { status('info', 'A VIN uses letters and numbers only (no I, O or Q). Please check it, or simply continue.'); return; }
      // Saved right away, so the next product pages are pre-filled even if the lookup is slow or the customer moves on.
      var prev = load();
      if (!prev || prev.vin !== vin) save({ vin: vin, label: '' });
      status('info', 'Looking up your car&hellip;');
      decode(vin).then(function (car) {
        if (cleanVin(input.value) !== vin) return;
        save({ vin: vin, label: car.label });
        onCar(car, status);
      }).catch(function () {
        if (cleanVin(input.value) !== vin) return;
        save({ vin: vin, label: '' });
        status('info', 'We couldn’t read this VIN automatically. No worries: it’s saved, and you can pick your car below.');
      });
    }
    input.addEventListener('input', function () {
      var pos = input.selectionStart, up = input.value.toUpperCase();
      if (up !== input.value) { input.value = up; try { input.setSelectionRange(pos, pos); } catch (e) {} }
      run();
    });
    input.addEventListener('change', run);
    return { run: run, status: status };
  }

  function initNav(root) {
    var nav = root.closest('quick-nav');
    var input = root.querySelector('.erp-vin__input');
    if (!nav || !input || input.dataset.erpBound) return;
    input.dataset.erpBound = '1';
    bind(input, root.querySelector('.erp-vin__status'), function (car, status) { fillNav(nav, car, status); });
  }

  function initProduct(root) {
    var input = root.querySelector('.erp-vin__input');
    if (!input || input.dataset.erpBound) return;
    input.dataset.erpBound = '1';
    var b = bind(input, root.querySelector('.erp-vin__status'), function (car, status) {
      status('ok', 'Recognized: <strong>' + car.label + '</strong>. We’ll keep it with your order.');
    });
    var saved = load();
    if (saved && saved.vin && !input.value) { input.value = cleanVin(saved.vin); b.run(); }
  }

  function initAll() {
    document.querySelectorAll('[data-erp-vin="nav"]').forEach(initNav);
    document.querySelectorAll('[data-erp-vin="product"]').forEach(initProduct);
  }
  window.ErpVin = { decode: decode, init: initAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
